import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../components/layout";
import { Link } from "gatsby";
import styled from "styled-components";
import { PrimaryButton } from "../../components/Buttons";
import { SecondaryButton } from "../../components/Buttons";
import YearMinus15 from '../../components/YearMinus15';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 className="form-title">Is your building over 15 years old?</h1>
    <p className="form-description">The rent cap law includes age requirements for the building in which tenants live.
The age of your building is based on when it was first licensed to be rented,
 not when it was was last renovated, painted, or cleaned. 
 If your building was opened in <YearMinus15 mdxType="YearMinus15"></YearMinus15> or earlier, click “Yes”.
    </p>
    <div className="form-button-container age-check-form">
  <PrimaryButton to="/coverage/old-enough" mdxType="PrimaryButton">
    Yes
  </PrimaryButton>
  &nbsp;
  <PrimaryButton to="/coverage/not-covered" mdxType="PrimaryButton">No</PrimaryButton>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      